import React from 'react';

import Heading, { THeadingLevels } from '@/components/switchback/Heading/Heading';
import Link from '@/components/switchback/Link/Link';

interface ICategoryTitleLink {
  title: string;
  slug?: string;
  level?: THeadingLevels;
  headingClassName?: string;
}

const CategoryTitleLink: React.FC<ICategoryTitleLink> = ({
  slug,
  title,
  level = 2,
  headingClassName,
}) => {
  const headingTitle = (
    <Heading
      level={level}
      className={`mb-2 ml-4 highlight font-medium text-700 lg:ml-0 ${headingClassName}`}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  );

  if (!slug) {
    return headingTitle;
  }

  return (
    <>
      <Link legacy href="/blog/category/[categorySlug]" as={`/blog/category/${slug}`}>
        <a href={`/blog/category/${slug}`} title={title}>
          {headingTitle}
        </a>
      </Link>
    </>
  );
};

export default CategoryTitleLink;
